export default "__VITE_ASSET__BdwAegxo__"